import { i18n } from '@/plugins/i18n.client';
import DateFnsAdapter from '@date-io/date-fns';
import * as locales from 'date-fns/locale';

// Load main project styles (overrides) via JS so that they will be loaded AFTER vuetify bundle
// import '@/src/styles/main.scss';
import { colors as palette } from '@/src/styles/common/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { aliases } from 'vuetify/iconsets/md';

// import { aliases, fa } from 'vuetify/iconsets/fa';
// import { mdi } from 'vuetify/iconsets/mdi';
// make sure to also import the coresponding css
// import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import '@fortawesome/fontawesome-pro/css/all.css'; // Ensure your project is capable of handling css files
// import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'html-query-plan/css/qp.css';
import '@/src/styles/main.scss';

// Icons
import { materialSymbols } from './helpers/materialSymbols';
import { vuetifyDefaults } from './helpers/vuetifyDefaults';

export const vuetifyOptions = {
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          ...palette
          // background: '#F5F6FA',
          // 'on-surface': '#0C233C',
          // 'on-background': '#0C233C'
          // 'on-primary': '#FFFFFF',
          // 'on-textLightGray': '#FFFFFF',
          // 'on-warning': '#FFFFFF'
        },
        variables: {
          'high-emphasis-opacity': 1,
          'hover-opacity': 0
        }
      }
    }
  },
  icons: {
    defaultSet: 'ms',
    aliases: { ...aliases, checkboxOn: aliases.checkboxOn + '--filled' },
    sets: {
      ms: materialSymbols
    }
  },
  defaults: vuetifyDefaults,
  lang: {
    t: (key, ...params) => i18n.global.t(key, params)
  },
  date: {
    adapter: DateFnsAdapter,
    locale: { ...locales, en: locales.enUS }
  },
  datepicker: {
    header: false
  },
  components,
  directives,
  styles: { configFile: '/src/styles/variables.scss' }
};

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify(vuetifyOptions);
  window.vuetifyOptions = { ...vuetifyOptions };
  app.vueApp.use(vuetify, {
    customProperties: true
  });
  return {
    enforce: 'pre', // or 'post'
    provide: {
      vuetify: vuetify
    }
  };
});
